import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import { Validation } from '../../helpers/validations';
import { FileNoticeToVacate, FileNoticeToVacateWithoutTokenAction } from '../../redux/actions/noticeToVacate';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { withTranslation } from "react-i18next";
class NoticeToVacate extends Component{
  constructor(props){
    super(props);
    this.state = this.emptyState();
    this.sigPad = React.createRef();
  }

  componentDidMount(){
    const { user, withoutToken } = this.props;
    let name = "";
    let location = "";
    if (withoutToken) {
      // Un-authed flow: clean shape from GET /auth/get-profile/:leaseId/:id
      name = user?.userData?.name ?? "";
      const a = user?.lease?.address;
      if (a) {
        const unitPart = a.unit ? ` Unit ${a.unit}` : "";
        location = `${a.line1}${unitPart}, ${a.city}, ${a.state} ${a.zip}`;
      }
    } else {
      // Auth'd dashboard sidebar flow: legacy login-response shape
      name = user?.NameFull ?? "";
      const ld = user?.leaseDetails;
      if (ld) {
        const unit = ld["Lease_PROP::Number"];
        const unitPart = unit ? ` Unit ${unit}` : "";
        location = `${ld["Lease_PROP::Address_Address01_finalDisplay"]}${unitPart}, ${ld["Lease_PROP::Address_City"]}, ${ld["Lease_PROP::Address_State"]} ${ld["Lease_PROP::Address_PostalCode"]}`;
      }
    }
    this.setState({ formdata: { ...this.state.formdata, name, location } });
  }

  // function to initialize state and empty state
  emptyState(){
    let d = new Date
    let date = d.getDate() === 1 ? new Date(d.getFullYear(), d.getMonth(), 1) : new Date(d.getFullYear(), d.getMonth() + 1, 1)
    return {
      formdata : { date },
      showError: false,
    }
  }

  // handles form values
  handleChange = (key, value) => {
    this.setState(state => ({ formdata: {...state.formdata, [key]: value }}));
  }

  // get trimmed image of signature
  getTrim = () => {
    let trimmedUrl = this.sigPad.current.getTrimmedCanvas().toDataURL('image/png');
    let { formdata } = this.state;
    formdata["trimmedUrl"] = trimmedUrl;
    return formdata
  }

  // clears sign Pad
  clearSignPad = () => {
    this.sigPad.current.clear();
    this.setState(state => ({ formdata: {...state.formdata, trimmedUrl: "" }}))
  }

  // submits the form
  handleSubmit = async (event) => {
    event.preventDefault();
    const formdata = this.getTrim();
    this.setState({ showError: true, formdata });
    if(!formdata.date || !formdata.trimmedUrl) return;

    // Action layer accepts { date, trimmedUrl } and converts to ISO YYYY-MM-DD on the wire.
    // Loading state is owned by redux (NOTICE_VACATE_REDUCER.loading) — the action
    // dispatches LOADING / LOADING_STOP around the request.
    const payload = {
      date: moment(formdata.date).format("YYYY-MM-DD"),
      trimmedUrl: formdata.trimmedUrl,
    };
    if (this.props.withoutToken && this.props.leaseId) {
      this.props.FileNoticeToVacateWithoutTokenAction(payload, this.props.leaseId, this.props.onSuccess);
      return;
    }
    this.props.FileNoticeToVacate(payload, this.props.onSuccess);
  }

  render(){
    const { formdata, showError } = this.state;
    const { t, loading } = this.props;
    const inputsBlocked = loading
      ? { pointerEvents: "none", opacity: 0.6 }
      : undefined;
    return(
      <div className="notice-container">
        <div style={inputsBlocked}>
          <div className="form-group">
            <label>{t('modal.notice.legalName')}</label>
            <input
              className={`form-control form-control-lg ${showError && Validation.empty(formdata.name) ? "is-invalid" : ""}`}
              type="text"
              placeholder="Enter your Name"
              value={formdata.name}
              disabled
              onChange={e=> this.handleChange("name", e.target.value)}
            />
            <h5 className="invalid-feedback">{`${showError && Validation.empty(formdata.name) && "Name is required"}`}</h5>
          </div>
          <div className="form-group">
            <label>{t('modal.notice.address')}</label>
            <textarea
              className={`form-control form-control-lg ${showError && Validation.empty(formdata.location) ? "is-invalid" : ""}`}
              type="text"
              rows="3"
              disabled
              placeholder="Enter your Location"
              value={formdata.location}
              onChange={e=> this.handleChange("location", e.target.value)}
            />
            <h5 className="invalid-feedback">{`${showError && Validation.empty(formdata.location) && "Location is required"}`}</h5>
          </div>
          <label>{t('modal.notice.date')}</label>
          <div className="form-group">
            <DatePicker
              isClearable={true}
              minDate={new Date()}
              selected={formdata.date}
              onChange={date => this.handleChange("date", date)}
              className="form-control form-control-lg"
              disabled={loading}
            />
            <h5 className="invalid-feedback">{"Date to Vacate is required"}</h5>
          </div>
          <div className="form-group sign-container">
            <label>{t('modal.notice.signature')}</label>
            <div className="border">
              <SignatureCanvas
                penColor='black'
                backgroundColor="white"
                canvasProps={{width: 500, height: 100, className: 'sigCanvas'}}
                ref={this.sigPad}
                dotSize={1}
                minWidth={1}
                maxWidth={1}
                minDistance={1}
              />
              <span className="float-right">
                <i className="fas fa-redo hover-pointer" onClick={loading ? undefined : this.clearSignPad}/>
              </span>
            </div>
            <h5 className="invalid-feedback">{'Signature is required'}</h5>
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-primary btn-block"
          onClick={this.handleSubmit}
          disabled={loading}
        >
          {!loading ? `${t('modal.notice.submit')}` : <i className="fas fa-spinner fa-pulse" />}
        </button>
        {loading && (
          <p className="text-center text-muted mt-2 mb-0">{t('modal.notice.loadingMessage')}</p>
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ USER_REDUCER, NOTICE_VACATE_REDUCER }) => {
  return { user: USER_REDUCER.userData, loading: NOTICE_VACATE_REDUCER.loading }
}

export default connect(mapStateToProps, { FileNoticeToVacate, FileNoticeToVacateWithoutTokenAction })(withTranslation()(NoticeToVacate))